import { Component, OnInit, Input } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { __core_private_testing_placeholder__ } from '@angular/core/testing';
import { ActivatedRoute } from '@angular/router'

import { GraphSearchServiceService } from '../services/graph-search-service.service';
import { GraphVisualServiceService } from '../services/graph-visual-service.service'
import { listLazyRoutes } from '@angular/compiler/src/aot/lazy_routes';


@Component({
  selector: 'app-graph-visual',
  templateUrl: './graph-visual.component.html',
  styleUrls: ['./graph-visual.component.css']
})
export class GraphVisualComponent implements OnInit {

  options: any;
  chart_data;
  hasData = false;
  visible = false;
  showData;
  objectKeys;
  detailTitle: string;

  constructor(
    private graphSearchService: GraphSearchServiceService,
    private graphVisualService: GraphVisualServiceService,
    private notification: NzNotificationService,
    private route: ActivatedRoute
  ) { }

  @Input() detailDownload:any;

  ngOnInit() {

    this.route.url.subscribe(res => {
      this.root_flag = res[0].path;
    })

    //console.log(this.route)

    if (this.root_flag == "ppi") {
      this.loading = true;
      this.graphSearchService.graphVisual_sub.subscribe(res => {
        this.graphVisualService.getGraphVisualData('graph', null).subscribe((data: any) => {
          this.chart_data = data;
          this.setOption(this.chart_data);
          this.hasData = true;
        }, error => {
          this.hasData = false;
          this.notification.create(
            "error",
            'Oooooops~~~~',
            'Something went wrong when querying in knowledge graph. Please check your network and try it again.'
          );
        });
        this.loading = false;
      })
    }
    else if (this.root_flag == "protein_detail") {
      this.loading = true;
      this.route.paramMap.subscribe(param => {
        this.search_id = param.get("logic_id");
      })

      this.graphVisualService.getGraphVisualData('detail', this.search_id).subscribe((data: any) => {
        this.chart_data = data;
        this.setOption(this.chart_data);
        this.hasData = true;
      }, error => {
        this.hasData = false;
        this.notification.create(
          "error",
          'Oooooops~~~~',
          'Something went wrong when querying in knowledge graph. Please check your network and try it again.'
        );
      });
      this.loading = false;
    }


  }

  root_flag;
  search_id;
  loading = true;


  downloadChartData() {
    this.notification.create(
      "success",
      "",
      "Wait a moment! Download will take a few minutes..."
    );
    this.graphVisualService.downloadGraphVisualData(null).subscribe((data: any) => {
      const contentType = 'text/csv';
      const blob = new Blob([data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      const fileName = 'graphData';
      link.href = url;
      link.download = fileName + '.csv';
      link.click();
      window.URL.revokeObjectURL(url);
    }, error => {
      this.notification.create(
        "error",
        'Oooooops~~~~',
        'Download Error. Please check your network and try it again.'
      );
      console.log(error);
    });
  }





  setOption(chartData) {
    let dataLabel = new Array();
    let nodeEdgeMap = new Object()
    chartData.categories.forEach((val, idx, array) => {
      dataLabel.push(val)
    })

    chartData.nodes.forEach((node, idx) => {
      nodeEdgeMap[node.name] = idx;
    })

    chartData.links.map(function (link) {
      link.source = nodeEdgeMap[link.source];
      link.target = nodeEdgeMap[link.target]
      return link
    })

    this.options = {
      legend: {
        data: dataLabel
      },
      series: [{
        type: 'graph',
        layout: 'force',
        animation: false,
        label: {
          position: 'right',
          formatter: '{b}',
          color: 'auto',
        },
        draggable: true,
        data: chartData.nodes,
        categories: chartData.categories,
        force: {
          edgeLength: [30, 100],
          repulsion: 50,
          gravity: 0.2
        },
        links: chartData.links,
        lineStyle: {
          width: 1.2,
          curveness: 0.1
        },
        nodeScaleRatio: 0.6,
        focusNodeAdjacency: true,
        roam: true,
        edgeSymbol: ['circle', 'arrow'],
        edgeSymbolSize: 5,
        cursor: 'pointer',
        dataZoom: [
          {
            id: "dataZoomX",
            type: "slider",
            xAxisIndex: [0],
            filterMode: 'filter'
          },
          {
            id: "dataZoomY",
            type: "slider",
            yAxisIndex: [0],
            filterMode: 'filter'
          }
        ]
      }]
    };
  }

  onChartEvent(event: any) {
    if (event.dataType == 'node') {
      this.detailTitle = "Entity";
    }
    else {
      this.detailTitle = "Relation";
    }
    this.objectKeys = this.getObjectKeys(event.data);
    this.showData = event.data;
    this.visible = true;
  }

  onClose() {
    this.visible = false;
  }

  getObjectKeys(data) {
    return Object.keys(data);
  }



}
